import React from 'react';
import {
  FaPlaceOfWorship,
  FaTools,
  FaGavel,
  FaCompass,
  FaMountain,
} from 'react-icons/fa';

const services = [
  {
    title: 'Traditional Temple Design',
    icon: <FaPlaceOfWorship size={28} />,
    description: `We specialize in Agama-based Hindu temple design, ensuring each structure adheres to sacred principles and rituals. From Garbhagriha (sanctum sanctorum) to Gopurams (towers), every element is designed with deep spiritual significance, balancing divine proportions and regional styles.`,
  },
  {
    title: 'Vastu Consultation',
    icon: <FaCompass size={28} />,
    description: `Our Vastu consultation services are rooted in the ancient Indian science of architecture. We analyze site orientation, land energy, and structural layout to ensure harmony between the built environment and cosmic energies.`,
  },
  {
    title: 'Custom Idol Placement Planning',
    icon: <FaGavel size={28} />,
    description: `Correct idol placement is the cornerstone of spiritual efficacy in a temple. Our team ensures each deity is positioned according to Agamic rules and symbolic relationships, guiding your temple toward spiritual alignment.`,
  },
  {
    title: 'Stone & Wood Carving',
    icon: <FaMountain size={28} />,
    description: `Our artisans breathe life into stone and wood through intricate hand-carved sculptures. From divine idols to mandapams, each piece reflects sacred tradition and skilled craftsmanship.`,
  },
  {
    title: 'Temple Renovation',
    icon: <FaTools size={28} />,
    description: `We restore and rejuvenate temples with reverence — from artistic revival to structural reinforcement — preserving cultural heritage while meeting modern standards.`,
  },
];

const Services = () => {
  const royalBlue = '#002366';
  const background = '#f8faff';
  const darkText = '#2c2c2c';

  return (
    <section
      style={{
        minHeight: '100vh',
        width: '100vw',
        padding: '40px 5vw',
        backgroundColor: background,
        fontFamily: 'Georgia, serif',
        color: darkText,
        boxSizing: 'border-box',
      }}
    >
      {/* Title */}
      <h2
        style={{
          textAlign: 'center',
          color: royalBlue,
          fontSize: '2rem',
          marginBottom: '40px',
          fontWeight: 'bold',
        }}
      >
        OUR TEMPLE SERVICES
      </h2>

      {/* Responsive Grid */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: '40px',
        }}
      >
        {services.map((service, index) => (
          <div key={index} style={{ textAlign: 'justify' }}>
            <h3
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                fontSize: '1.2rem',
                color: royalBlue,
                marginBottom: '12px',
              }}
            >
              {service.icon} {service.title}
            </h3>
            <p
              style={{
                fontSize: '1.05rem',
                lineHeight: '1.8',
              }}
            >
              {service.description}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Services;








